module.exports = __webpack_public_path__ + "static/media/Cecrops.d5e1d1b3.jpg";